import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import AccessTimeRounded from '@material-ui/icons/AccessTimeRounded';
import AnnouncementRounded from '@material-ui/icons/AnnouncementRounded';
import AppsRounded from '@material-ui/icons/AppsRounded';
import AvTimerRounded from '@material-ui/icons/AvTimerRounded';
import BookmarksRounded from '@material-ui/icons/BookmarksRounded';
import CalendarViewDayRounded from '@material-ui/icons/CalendarViewDayRounded';
import CropSquareRounded from '@material-ui/icons/CropSquareRounded';
import DateRangeRounded from '@material-ui/icons/DateRangeRounded';
import DialpadRounded from '@material-ui/icons/DialpadRounded';
import EmojiObjectsRounded from '@material-ui/icons/EmojiObjectsRounded';
import EventRounded from '@material-ui/icons/EventRounded';
import ExtensionRounded from '@material-ui/icons/ExtensionRounded';
import FlipRounded from '@material-ui/icons/FlipRounded';
import FormatQuoteRounded from '@material-ui/icons/FormatQuoteRounded';
import GestureRounded from '@material-ui/icons/GestureRounded';
import GpsFixedRounded from '@material-ui/icons/GpsFixedRounded';
import HourglassEmptyRounded from '@material-ui/icons/HourglassEmptyRounded';
import ImageRounded from '@material-ui/icons/ImageRounded';
import LibraryBooksRounded from '@material-ui/icons/LibraryBooksRounded';
import LinkRounded from '@material-ui/icons/LinkRounded';
import MonetizationOnRounded from '@material-ui/icons/MonetizationOnRounded';
import NoteRounded from '@material-ui/icons/NoteRounded';
import PlaylistAddCheckRounded from '@material-ui/icons/PlaylistAddCheckRounded';
import ScheduleRounded from '@material-ui/icons/ScheduleRounded';
import SearchRounded from '@material-ui/icons/SearchRounded';
import TextFieldsRounded from '@material-ui/icons/TextFieldsRounded';
import TimerRounded from '@material-ui/icons/TimerRounded';
import TodayRounded from '@material-ui/icons/TodayRounded';
import TrendingUpRounded from '@material-ui/icons/TrendingUpRounded';
import ViewQuiltRounded from '@material-ui/icons/ViewQuiltRounded';
import ViewWeekRounded from '@material-ui/icons/ViewWeekRounded';
import WallpaperRounded from '@material-ui/icons/WallpaperRounded';
import WbSunnyRounded from '@material-ui/icons/WbSunnyRounded';
import WebRounded from '@material-ui/icons/WebRounded';
import WhatshotRounded from '@material-ui/icons/WhatshotRounded';
import WidgetsRounded from '@material-ui/icons/WidgetsRounded';
import WorkRounded from '@material-ui/icons/WorkRounded';
import s from './WidgetIcon.css';

/*
 * Иконка виджета на цветной плашке — как пункты левого меню в окне
 * настроек расширения. Цвет плашки задаёт категория, значок — сам виджет.
 * Неизвестный slug получает общий значок, а не падает.
 */
const ICONS = {
	countdown: HourglassEmptyRounded,
	'count-up': TrendingUpRounded,
	'day-countdown': TodayRounded,
	'workday-countdown': WorkRounded,
	clock: AccessTimeRounded,
	'analog-clock': ScheduleRounded,
	'flip-clock': FlipRounded,
	date: EventRounded,
	calendar: DateRangeRounded,
	'google-calendar': CalendarViewDayRounded,
	pomodoro: TimerRounded,
	timetable: ViewWeekRounded,
	'todo-list': PlaylistAddCheckRounded,
	notes: NoteRounded,
	'habit-tracker': WhatshotRounded,
	calculator: DialpadRounded,
	'flash-cards': LibraryBooksRounded,
	'daily-focus': GpsFixedRounded,
	'search-bar': SearchRounded,
	'top-sites': AppsRounded,
	bookmarks: BookmarksRounded,
	link: LinkRounded,
	'google-apps': AppsRounded,
	workspaces: ViewQuiltRounded,
	text: TextFieldsRounded,
	image: ImageRounded,
	quotes: FormatQuoteRounded,
	weather: WbSunnyRounded,
	figure: CropSquareRounded,
	iframe: WebRounded,
	wallpaper: WallpaperRounded,
	currency: MonetizationOnRounded,
	canvas: GestureRounded,
	news: AnnouncementRounded,
	facts: EmojiObjectsRounded,
	'chess-puzzle': ExtensionRounded,
	timer: AvTimerRounded,
};

const TONES = {
	Time: s.orange,
	Productivity: s.green,
	Navigation: s.blue,
	Content: s.indigo,
	Design: s.violet,
};

export default function WidgetIcon({ slug, category, size }) {
	useStyles(s);
	const Icon = ICONS[slug] || WidgetsRounded;
	const tone = TONES[category] || s.accent;

	return (
		<span
			className={`${s.root} ${tone} ${size === 'large' ? s.large : ''}`}
			aria-hidden="true"
		>
			<Icon />
		</span>
	);
}

WidgetIcon.propTypes = {
	slug: PropTypes.string.isRequired,
	category: PropTypes.string,
	size: PropTypes.oneOf(['normal', 'large']),
};

WidgetIcon.defaultProps = {
	category: undefined,
	size: 'normal',
};
